import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';
import { SOCIETY_MANAGEMENT, SOCIETY_MANAGEMENT_COMMUNICATION_SETTINGS } from '../../../Routing/routes';
import CommunicationSettingsLayer from './Component/CommunicationSettingsLayer';

const CommunicationSettings = () => {
    const { id } = useParams();
    // The list passes the community name along; a direct visit falls back to the id.
    const societyName = useLocation().state?.societyName;
    const links = [
        { to: SOCIETY_MANAGEMENT, text: 'Community Management' },
        { to: SOCIETY_MANAGEMENT_COMMUNICATION_SETTINGS.replace(':id', id), text: 'Communication Settings' },
    ];

    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                description={societyName
                    ? `Allow or deny sending billing documents to members of ${societyName}`
                    : 'Allow or deny sending billing documents to members'}
                links={links}
                headingTitle="Communication Settings"
            />
            <CommunicationSettingsLayer societyId={id} societyName={societyName} />
        </>
    );
};

export default CommunicationSettings;
